import React from 'react'
import Icon from './icon'

const Tags = ({
  viewBox = '0 0 24 24',
  style = { fill: '#e3e3e3', height: 200, width: 200 }
}) => {
  return (
    <Icon viewBox={viewBox} style={style}>
      <g>
        <path d="M2.53,19.65l1.34,0.56v-9.03l-2.43,5.86C1.03,18.06,1.52,19.23,2.53,19.65z" />
        <path d="M22.03,15.95L17.07,3.98c-0.31-0.75-1.04-1.21-1.81-1.23c-0.26,0-0.53,0.04-0.79,0.15L7.1,5.95
			c-0.75,0.31-1.21,1.03-1.23,1.8c-0.01,0.27,0.04,0.54,0.15,0.8l4.96,11.97c0.31,0.76,1.05,1.22,1.83,1.23
			c0.26,0,0.52-0.05,0.77-0.15l7.36-3.05C21.96,18.13,22.45,16.96,22.03,15.95z M12.83,19.75L7.87,7.79l7.35-3.04c0,0,0,0,0.01,0
			l4.95,11.95L12.83,19.75z" />
        <circle cx="11" cy="9" r="1" />
        <path d="M5.88,19.75c0,1.1,0.9,2,2,2h1.45l-3.45-8.34V19.75z" />
      </g>
    </Icon>
  )
}

export default Tags



// WEBPACK FOOTER //
// ./src/components/Icons/tags.js